module.exports = __webpack_public_path__ + "img/icon-clock-white.d339f7fe.svg";